import PropTypes from "prop-types";
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Route, useHistory } from "react-router-dom";
import { isUserAuthenticated } from "../../../redux/actions/authentication";
import { getItemFromStorage } from "../../../helper/storage";

const NO_COMPANY_EXEMPT = ["/selecionar-empresa", "/empresa/cadastro", "/aceitar/convite"];

const PrivateRoute = ({ children, ...rest }) => {
  const history = useHistory();
  const demo = useSelector(state => state.demo);

  useEffect(() => {
    const checkAuth = async () => {
      const authenticated = await isUserAuthenticated();
      if (!demo.isDemoMode && !authenticated) {
        history.push("/login");
        return;
      }
      if (authenticated && !demo.isDemoMode && !NO_COMPANY_EXEMPT.includes(rest.path)) {
        const companyId = getItemFromStorage("COMPANY_ID");
        if (!companyId) {
          history.push("/selecionar-empresa");
        }
      }
    };
    checkAuth();
  }, [history, demo.isDemoMode, rest.path]);

  return (
    <Route
      path={rest.path}
      exact={rest.exact}
      render={() => children}
    />
  );
};

PrivateRoute.propTypes = {
  exact: PropTypes.bool.isRequired,
  path: PropTypes.string.isRequired
};

export default PrivateRoute;
